import { LineChart } from './LineChart';
import { BarChart } from './BarChart';
import { LatestValueChart } from './LatestValueChart';

export type DataSourceType = string;
export type ChartType = 'line' | 'bar' | 'single';
export type TimeSeriesValue = string | number | null;

export interface TimeSeriesPoint {
    timestamp: string;
    values: Record<string, TimeSeriesValue>;
    tags?: Record<string, string>;
}

export interface TimeSeriesResponse {
    source: 'timestream' | 'influx';
    rows: TimeSeriesPoint[];
}

export type TimeSeriesChartRow = {
    timestamp: string;
    [key: string]: TimeSeriesValue | string;
};

export function toTimeSeriesChartRows(points: TimeSeriesPoint[]): TimeSeriesChartRow[] {
    return points.map((point) => ({
        timestamp: point.timestamp,
        ...point.values,
    }));
}

export interface Tile {
    id: string;
    title: string;
    dataSource: DataSourceType;
    chartType: ChartType;
    data: TimeSeriesChartRow[];
}

export function TileDisplay({ tile }: { tile: Tile; }) {
    if (!tile.data) {
        return <WithTitle title={tile.title}>
            <div>Could not fetch data.</div>
        </WithTitle>;
    }

    const valueKeys = Array.from(
        new Set(
            tile.data.flatMap(item =>
                Object.entries(item)
                    .filter(([key, value]) => key !== "timestamp" && typeof value === 'number' && Number.isFinite(value))
                    .map(([key]) => key)
            )
        )
    );

    switch (tile.chartType) {
        case 'line':
            return (
                    <LineChart tile={tile} valueKeys={valueKeys} />
            );
        case 'bar':
            return (
                    <BarChart tile={tile} valueKeys={valueKeys} />
            );
        case 'single':
            return (
                    <LatestValueChart tile={tile} valueKeys={valueKeys}/>
            );
        default:
            return <div>Invalid chart type</div>;
    }

}

export function WithTitle({ title, children }: { title: string, children: React.ReactNode }) {
    return (
        <>
            <div className="tile-header d-flex justify-content-between align-items-center mb-2">
                <h5 className="m-0">{title}</h5>
            </div>
            {children}
        </>
    );
}